<template>
    <div class="scrollBar">
        <div class="heading flex">
            <div class="back flex mr-2 pointer" @click="goback">
                <v-icon color="#1D8D56">mdi-arrow-left</v-icon>
            </div>
            <div class="head --green">Comments</div>
        </div>
        <div class="text-center" v-if="loading" style="min-height: 500px">
            <v-progress-circular
                :size="60"
                :width="5"
                style="
                    text-align: center;
                    padding-top: 200px;
                    margin-top: 100px;
                    width: 100px;
                "
                color="#6FB793"
                indeterminate
            ></v-progress-circular>
        </div>
        <v-row
            style="overflox-y: auto"
            class="mt-3"
            v-for="(i, index) in commentsList"
            :key="index"
            v-else
        >
            <v-col cols="1">
                <v-list-item-avatar tile>
                    <img
                        :src="i.user.image ? i.user.image.small : dummyAvatar"
                    />
                </v-list-item-avatar>
            </v-col>
            <v-col cols="11">
                <div class="comment-by">
                    <span class="name">{{ i.user.full_name }}</span>
                    <span class="comment-date" style="float: right">
                        <time-ago :datetime="i.modified_at" long></time-ago>
                    </span>
                    <span style="clear: both"> &nbsp; </span>
                    <div class="comment-txt">
                        {{ i.comment_text }}
                    </div>

                    <div
                        class="reply pointer --green"
                        @click="i.liked_by_user = !i.liked_by_user"
                    >
                        <span v-if="i.nested_comment.length > 0">{{
                            i.nested_comment.length
                        }}</span>
                        Reply
                    </div>

                    <!--Nested Comments Session Start-->
                    <div v-if="i.liked_by_user">
                        <v-row
                            class="mt-1"
                            v-for="(item, index2) in i.nested_comment"
                            :key="index2"
                        >
                            <v-col cols="1">
                                <v-list-item-avatar tile>
                                    <img
                                        :src="
                                            i.user.image
                                                ? i.user.image.small
                                                : dummyAvatar
                                        "
                                    />
                                </v-list-item-avatar>
                            </v-col>
                            <v-col cols="11">
                                <div class="comment-by">
                                    <span class="name">{{
                                        item.user.full_name
                                    }}</span>
                                    <span
                                        class="comment-date"
                                        style="float: right"
                                    >
                                        <time-ago
                                            :datetime="item.modified_at"
                                            long
                                        ></time-ago>
                                    </span>
                                    <span style="clear: both"> &nbsp; </span>
                                    <div class="comment-txt">
                                        {{ item.comment_text }}
                                    </div>
                                </div>
                            </v-col>
                        </v-row>
                        <v-row class="pt-3">
                            <v-col>
                                <v-text-field
                                    filled
                                    light
                                    outlined
                                    v-model="nextedCommentTest"
                                    placeholder="Add a comment.."
                                    @click:append="
                                        nextedAddComment(i.id, index)
                                    "
                                    background-color="#F6F9F6"
                                    @keyup.enter="nextedAddComment(i.id, index)"
                                    append-icon="mdi-send"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                    </div>
                    <!--Nested Comments Session End-->
                </div>
            </v-col>
        </v-row>

        <v-row
            class="pt-3"
            style="position: sticky; bottom: 0; background-color: white"
        >
            <v-col cols="12">
                <v-text-field
                    filled
                    light
                    outlined
                    v-model="commentTest"
                    placeholder="Add a comment.."
                    @click:append="addComment"
                    background-color="#F6F9F6"
                    @keyup.enter="addComment"
                    append-icon="mdi-send"
                ></v-text-field>
            </v-col>
        </v-row>
    </div>
</template>
<script>
import API_URL from "../../../../helpers/apiUrls";
import { TimeAgo } from "vue2-timeago";
import accessToken from "../../../../helpers/accessToken";

export default {
    name: "comment",
    components: { TimeAgo },
    props: ["type"],
    data() {
        return {
            loading: false,
            comments_replys_flag: false,
            commentsList: [],
            commentsId: "",
            commentTest: "",
            nextedCommentTest: "",
            dummyAvatar: require("../../../../assets/DummyAvatar.png"),
        };
    },
    mounted() {
        this.getCommentList();
    },
    methods: {
        goback() {
            this.$emit("back", false);
        },

        getCommentList() {
            // console.log("asd", this.type);
            // console.log("JSON",localStorage.getItem("Brand-ID"))
            this.loading = true;
            const successHandler = (response) => {
                if (response.status === 200) {
                    this.commentsList = response.data.results;
                }
                this.loading = false;
            };

            const errorHandler = (error) => {
                this.loading = false;
               this.showToast('Something went wrong internally!', 'error', 10000);
                console.log(error);
            };
            const data = {
                id:
                    this.type == "poll"
                        ? this.$store.state.createContentStore
                              .createContent__Poll.id
                        : this.type == "post"
                        ? this.$store.state.createContentStore
                              .createContent__Post.id
                        : this.type == "video"
                        ? this.$store.state.createContentStore
                              .createContent__Video.id
                        : "",
                //Post ID
                feed_type:
                    this.type == "poll"
                        ? this.$store.state.createContentStore
                              .createContent__Poll.feedtype
                        : this.type == "post"
                        ? this.$store.state.createContentStore
                              .createContent__Post.feedtype
                        : this.type == "video"
                        ? this.$store.state.createContentStore
                              .createContent__Video.feedtype
                        : "",

                page: "1",
                business_id: `${localStorage.getItem("Brand-ID")}`,
            };
            this.requestGET(
                API_URL.createContent__comment,
                data,
                {},
                successHandler,
                errorHandler
            );
        },
        addComment() {
            this.loading = true;
            const successHandler = (response) => {
                // this.loading = false;
                if (response.status === 200) {
                    this.getCommentList();
                    this.commentTest = "";
                    this.loading = false;
                }
            };
            const errorHandler = (error) => {
                this.loading = false;
                this.showToast('Something went wrong internally!', 'error', 10000);
                console.log(error);
            };
            const data = {
                feed_type:
                    this.type == "poll"
                        ? this.$store.state.createContentStore
                              .createContent__Poll.feedtype
                        : this.type == "post"
                        ? this.$store.state.createContentStore
                              .createContent__Post.feedtype
                        : this.type == "video"
                        ? this.$store.state.createContentStore
                              .createContent__Video.feedtype
                        : "",
                comment: this.commentTest,
                post_id:
                    this.type == "poll"
                        ? this.$store.state.createContentStore
                              .createContent__Poll.id
                        : this.type == "post"
                        ? this.$store.state.createContentStore
                              .createContent__Post.id
                        : this.type == "video"
                        ? this.$store.state.createContentStore
                              .createContent__Video.id
                        : "",
                comment_author_type: "business",
                business_id: `${localStorage.getItem("Brand-ID")}`,
            };

            const headers = {
                Authorization: `Bearer ${accessToken.getAccessToken()}`,
            };

            this.requestPOST(
                API_URL.createContent__comment,
                data,
                headers,
                successHandler,
                errorHandler
            );
        },
        nextedAddComment(id, index) {
            this.loading = true;
            const successHandler = (response) => {
                if (response) {
                    // console.log("COMNETT:",this.nextedCommentTest);
                    // console.log("id:",id);

                    // this.commentList[index].nested_comment.push({
                    //     id : id,
                    //     comment_text : this.nextedCommentTest,
                    //     liked_by_user : true,
                    //     user : {
                    //         id:"aa",
                    //         full_name : "test",
                    //         image:{ small :""}
                    //     },
                    //     modified_at : 'now'
                    //     })
                    //     console.log("DAT::::",this.commentList[index].nested_comment)
                    this.nextedCommentTest = "";
                    this.getCommentList();
                    this.loading = false;
                }
            };
            const errorHandler = (error) => {
                this.loading = false;
                this.showToast('Something went wrong internally!', 'error', 10000);
                console.log(error);
            };
            const data = {
                feed_type:
                    this.type == "poll"
                        ? this.$store.state.createContentStore
                              .createContent__Poll.feedtype
                        : this.type == "post"
                        ? this.$store.state.createContentStore
                              .createContent__Post.feedtype
                        : this.type == "video"
                        ? this.$store.state.createContentStore
                              .createContent__Video.feedtype
                        : "",
                comment: this.nextedCommentTest,
                post_id:
                    this.type == "poll"
                        ? this.$store.state.createContentStore
                              .createContent__Poll.id
                        : this.type == "post"
                        ? this.$store.state.createContentStore
                              .createContent__Post.id
                        : this.type == "video"
                        ? this.$store.state.createContentStore
                              .createContent__Video.id
                        : "",
                comment_author_type: "business",
                business_id: `${localStorage.getItem("Brand-ID")}`,
                id: id,
            };

            const headers = {
                Authorization: `Bearer ${accessToken.getAccessToken()}`,
            };

            this.requestPOST(
                API_URL.createContent__nestedComment,
                data,
                headers,
                successHandler,
                errorHandler
            );
        },
    },
};
</script>
<style scoped>
.v-avatar img {
    border-radius: 3px !important;
}
.reply {
    font-style: normal;
    font-weight: 500;
    font-size: 12px;
    line-height: 0px;
    text-align: left;
    padding: 10px;
}
.comment-txt {
    font-family: "Roboto";
    font-style: normal;
    font-weight: 500;
    font-size: 13px;
    line-height: 18px;
    color: #445149;
    text-align: justify;
    padding: 10px;
}
.comment-date {
    font-weight: 400;
    font-size: 12px;
    line-height: 18px;
    color: #445149;
    text-align: right;
    padding-right: 10px;

    font-family: "Roboto";
    font-style: normal;
}
.name {
    padding-left: 10px;
    float: left;
    font-weight: 400;
    font-size: 16px;
    line-height: 18px;
}
.comment-by {
    font-family: "Roboto";
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 18px;
    color: #445149;
}
.avtar-txt {
    font-weight: 500;
    font-size: 16px;
    line-height: 18px;
    color: #bd993b;
}
.head {
    font-family: "Roboto";
    font-style: normal;
    font-weight: 500;
    font-size: 20px;
    line-height: 0px;
}
.heading {
    justify-content: flex-start;
    position: sticky;
    top: 0;
    padding-top: 20px;
    background-color: white;
    z-index: 1;
}
.back {
    background: #eff6f3;
    border-radius: 7px;
    width: 45px;
    height: 45px;
}
</style>
